import { connect } from 'react-redux';
import { selectProduct } from 'Favourites/store/reducers/data/products';

import {
    selectSelectedStoreId,
} from 'store/reducers/data/stores';

const mapStateToProps = (state, ownProps) => {
    const store = selectSelectedStoreId(state);
    const productData = selectProduct(state, ownProps.parentArticle);
    const availability = productData.stockAvailability;
    const quantity = productData.quantity;

    return { store, availability, quantity };
};

export default connect(mapStateToProps);
